<template>
	<div class="left_navbar" :style="{ top: windowCenterTop }" v-if="list">
		<div class="mid">
			<div class="icon" :class="{ on: leftIndex == v.name }" v-for="(v, i) in list" :key="i" @click="openChlidren(v, i)">
				<a href="javascript:void(0)"><img :src="v.icon || v.leftIconUrl" /></a>
				<div>{{ v['name' + En] }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'left_navbar',
	props: {
		maidian: {
			type: String,
			default: ''
		}
	},
	data() {
		return {

		}
	},
	methods: {
		// 点击二级菜单
		openChlidren(c, leftIndex) {
			let type = c.type
			if (c.multipleFileSts == 0) {
				this.$store.commit('setLeftIndex', c.name)
				this.$store.commit('setPageName', c)
				this.openLink({ link: '/match_process?code=' + c.code + (this.ExhibitDetail.uuid?'&pageType=exhibitPage':'&pageType=homePage') + '&type=more' })
				return
			}
			if (type == 1 || type == 2) {
				this.$store.commit('setLeftIndex', c.name)
				this.$store.commit('setPageName', c)
				this.openLink({ link: '/match_process?code=' + c.code + (this.ExhibitDetail.uuid?'&pageType=exhibitPage':'&pageType=homePage') })
			} else if (type == 3) {
				window.open(c['outLink' + this.En] || c.outLink);
			} else if (type == 4) {
				window.open(c['fileUrl' + this.En] || c['fileUrl'] || c.outLink);
			} else {
				this.$store.commit('setPageName', c)
				this.$store.commit('setLeftIndex', c.name)
				this.openLink(c)
			}
			if (this.maidian) {
				this.$jsAPI('track', 'ciif_exServices_leftPanel', {
					contentID_var: '无',
					contentName_var: c.name
				})
			}
			if (this.ExhibitDetail && this.ExhibitDetail.uuid) {
				this.$jsAPI('track', 'ciif_gbzyExhibition_leftPanel', {
					contentID_var: '无',
					contentName_var: c.name
				})
			}
		},
		// 点击一级菜单
		openLink(v) {
			if (v.link) {
				if (v.link === 'data_down') {
					this.$router.push(v.link + '?pageType=zhml')
				} else if (v.link === 'news_publish') {
					this.$router.push(v.link + '?pageType=goodNews')
				} else {
					this.$router.push({ path: v.link, query: v.query})
				}
			}
		},
	},
	computed: {
		...mapState({
			headList: state => state.headList,
			headIndex: state => state.headIndex,
			leftIndex: state => state.leftIndex,
			ExhibitDetail: state => state.ExhibitDetail,
			FunctionModule: state => state.FunctionModule
		}),
		list() {
			if (this.ExhibitDetail.uuid) {
				return this.FunctionModule
			} else if (this.headIndex >= 0 && this.headList.length > 0) {
				return this.headList[this.headIndex].children
			}
		}
	}
}
</script>

<style lang="less">
.left_navbar {
	width: 1.22rem;
	/*height: 7.4rem;*/
	/*background-image: url(~@/assets/images/leftbg.png);*/
	background: rgba(98, 100, 99, 0.8);
	border-radius: 0 .4rem .4rem 0;
	background-size: 100% 100%;
	position: fixed;
	display: flex;
	padding: .5rem 0;
	align-items: center;
	justify-content: center;
	left: 0;
	z-index: 99;
	top: 50%;
	transform: translateY(-50%);

	.mid {
		width: 100%;

		.icon {
			width: .6rem;
			height: .6rem;
			margin: 0 auto;
			position: relative;
			margin-bottom: .28rem;
			border-radius: 50%;

			&:last-child {
				margin-bottom: 0;
			}

			&:hover div {
				opacity: 1;
				visibility: inherit;
				left: .3rem;
			}

			div {
				height: .49rem;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				display: flex;
				align-items: center;
				white-space: nowrap;
				justify-content: flex-start;
				background: #fff;
				border-radius: 0 .16rem .16rem 0;
				padding: 0 .28rem 0 .46rem;
				text-align: center;
				font-size: .2rem;
				font-family: syb;
				color: #3C3C3C;
				transition: all .2s;
				cursor: pointer;
				visibility: hidden;
				opacity: 0;
			}

			img {
				width: 100%;
				height: 100%;
				position: relative;
				z-index: 9;
			}
		}

		.on {
			div {
				opacity: 1;
				visibility: inherit;
				left: .3rem;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/left_navbar.vue